import {
  CATEGORY_TYPES,
  AddCategoryAction,
  EditCategoryAction,
  GetAllCategoriesAction,
  GetAllCategoriesSuccessAction,
  GetOneCategoryAction,
  GetOneCategorySuccessAction,
  SetApiCategoryRequestStateAction,
  SetApiCategoryRequestErrorAction,
  SetApiCategoriesRequestStateAction,
  SetApiCategoriesRequestErrorAction,
  ResetCategoryAction,
  GetCategoriesTreeAction,
  GetCategoriesTreeSuccessAction,
  DeleteCategoryAction,
} from './categoryTypes';
import { CategoryFilterValues, CategoryGetResponse, CategoryParams, CategoryValues } from '../model/categoryModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export const setApiCategoryRequestState = (
  apiCategoryRequestState: API_REQUEST_STATE,
): SetApiCategoryRequestStateAction => ({
  type: CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_STATE,
  payload: {
    apiCategoryRequestState: apiCategoryRequestState,
  },
});

export const setApiCategoryRequestError = (apiCategoryRequestError: string): SetApiCategoryRequestErrorAction => ({
  type: CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_ERROR,
  payload: {
    apiCategoryRequestError: apiCategoryRequestError,
  },
});

export const setApiCategoriesRequestState = (
  apiCategoriesRequestState: API_REQUEST_STATE,
): SetApiCategoriesRequestStateAction => ({
  type: CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_STATE,
  payload: {
    apiCategoriesRequestState: apiCategoriesRequestState,
  },
});

export const setApiCategoriesRequestError = (
  apiCategoriesRequestError: string,
): SetApiCategoriesRequestErrorAction => ({
  type: CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_ERROR,
  payload: {
    apiCategoriesRequestError: apiCategoriesRequestError,
  },
});

export const addCategory = (category: CategoryValues): AddCategoryAction => ({
  type: CATEGORY_TYPES.ADD,
  payload: {
    category: category,
  },
});

export const resetCategory = (): ResetCategoryAction => ({
  type: CATEGORY_TYPES.RESET,
  payload: null,
});

export const editCategory = (params: CategoryParams, category: CategoryValues): EditCategoryAction => ({
  type: CATEGORY_TYPES.EDIT,
  payload: {
    category: category,
    params: {
      id: params.id,
    },
  },
});

export const deleteCategory = (params: CategoryParams): DeleteCategoryAction => ({
  type: CATEGORY_TYPES.DELETE,
  payload: {
    params: {
      id: params.id,
    },
  },
});

export const getAllCategories = (categoryFilter: CategoryFilterValues): GetAllCategoriesAction => ({
  type: CATEGORY_TYPES.GET_ALL,
  payload: {
    categoryFilter: categoryFilter,
  },
});

export const getAllCategoriesSuccess = (categories: CategoryGetResponse[]): GetAllCategoriesSuccessAction => ({
  type: CATEGORY_TYPES.GET_ALL_SUCCESS,
  payload: {
    categories: categories,
  },
});

export const getCategory = (params: CategoryParams): GetOneCategoryAction => ({
  type: CATEGORY_TYPES.GET_ONE,
  payload: {
    params: {
      id: params.id,
    },
  },
});

export const getOneCategorySuccess = (category: CategoryGetResponse): GetOneCategorySuccessAction => ({
  type: CATEGORY_TYPES.GET_ONE_SUCCESS,
  payload: {
    category: category,
  },
});

export const getCategoriesTree = (categoryParams: CategoryParams): GetCategoriesTreeAction => ({
  type: CATEGORY_TYPES.GET_TREE,
  payload: {
    params: categoryParams,
  },
});

export const getCategoriesTreeSuccess = (categories: CategoryGetResponse[]): GetCategoriesTreeSuccessAction => ({
  type: CATEGORY_TYPES.GET_TREE_SUCCESS,
  payload: {
    categories: categories,
  },
});
